import { render, staticRenderFns } from "./DownloadTest.vue?vue&type=template&id=7d50c5ab&scoped=true"
import script from "./DownloadTest.vue?vue&type=script&lang=js"
export * from "./DownloadTest.vue?vue&type=script&lang=js"
import style0 from "./DownloadTest.vue?vue&type=style&index=0&id=7d50c5ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d50c5ab",
  null
  
)

export default component.exports